import React, { useState } from "react";
import { Button, Modal } from "antd";
import { useTranslation } from "react-i18next";

const OrderDetailButton = ({ record }) => {
  const { t } = useTranslation();
  console.log(record, "record bro");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const formatCreatedAt = (createdAt) => {
    const date = new Date(createdAt);
    return date.toLocaleString();
  };

  console.log(record, "not started");
  return (
    <>
      <Button
        type="primary"
        className="text-white bg-blue-500"
        onClick={showModal}
      >
        {t("Detail")}
      </Button>
      <Modal
        centered
        open={isModalOpen}
        onOk={handleOk}
        okType="default"
        okText="Ok"
        cancelText="cancel"
        onCancel={handleCancel}
      >
        <div className="flex space-y-6 flex-col ">
          <div>
            <p className="font-bold text-xl text-[#001529]">
              {t("Order Information")}
            </p>
          </div>
          <div className="flex flex-col justify-center text-[#001529] text-lg ">
            <p>
              {t("Order Number")} : {record?.jobId}
            </p>
            {/* <p>{t("Client Local Time")} : 12:09 PM (GMT-5)</p> */}
            <p>
              {t("Priority")} : {record?.priority}
            </p>
          
            <p>
              {t("Title")} : {record?.title}
            </p>
            {/* <p>{t("Client Name")} : {record?.jobPoster?.name}</p> */}
            <p>
              {t("Price")} : {record?.price}$
            </p>
            <p>
              {t("Job Posted At")} : {formatCreatedAt(record?.createdAt)}
            </p>
          </div>
        </div>
      </Modal>
    </>
  );
};
export default OrderDetailButton;
